



























































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { IntlMixin } from 'vuemixins/intl_mixin'
import OzButton from 'library/v4/components/oz-button.vue'

@Component({ components: { OzButton } })
export default class SurfacePostModeration extends Mixins(IntlMixin) {
  @Prop({ required: true }) colorScheme!: 'light' | 'dark'
  @Getter isStream!: boolean

  deletePost(): void {
    this.$emit('delete')
  }
  approve(): void {
    this.$emit('approve')
  }
}
